import type { PageContent, PromiseItem, ValueStatement } from '../schema';

export const values = [
  {
    title: 'Quality Craftsmanship',
    description:
      'We maintain the highest standards in silk weaving, ensuring each piece is a masterpiece of artisanal excellence.',
    icon: 'star',
  },
  {
    title: 'Customer First',
    description:
      'Your satisfaction is our priority. We strive to provide personalized service and memorable experiences.',
    icon: 'users',
  },
  {
    title: 'Heritage & Innovation',
    description:
      'While honoring traditional techniques, we embrace innovation to create contemporary designs that resonate with modern aesthetics.',
    icon: 'heart',
  },
] satisfies readonly ValueStatement[];

export const promises = [
  {
    title: 'Sustainability',
    description:
      'Crafting sarees that transcend trends. We use durable materials and timeless designs to create heirlooms that can be cherished for generations.',
  },
  {
    title: 'Reliability',
    description:
      'Generations of trust, expertise, and consistent quality ensure every customer feels confident in our creations.',
  },
  {
    title: 'Elegance',
    description:
      'A commitment to timeless beauty. Every saree tells a unique story of grace, sophistication, and cultural pride.',
  },
  {
    title: 'Excellence',
    description: 'Uncompromising standards from selecting the finest fabrics to achieving intricate craftsmanship.',
  },
] satisfies readonly PromiseItem[];

export const aboutPageContent = {
  id: 'about',
  title: 'About Sree Silks',
  description: 'A legacy of silk craftsmanship, quality, and modern celebration.',
  sections: [
    {
      id: 'legacy',
      title: 'A Legacy of Silk Craftsmanship',
      description:
        'Five generations of textile knowledge guide how we select, style, and share sarees for modern families.',
    },
    {
      id: 'promise',
      title: 'The SREE Promise',
      description: 'Sustainability, reliability, elegance, and excellence shape every customer experience.',
    },
  ],
} satisfies PageContent;
